export default "__VITE_ASSET__phSmLaVi__"